import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmSelect from '@/components/form/elements/LmSelect'
export default {
  data () {
    return {
      component: {},
      idOptionsSameAsValidationSelected: ''
    }
  },
  components: {
    LmTextInput,
    LmNumberInput,
    LmSelect
  },
  props: {
    optionsSameAsValidation: {
      type: Object,
      default: () => ({})
    },
    componentData: {
      type: Object,
      default: () => ({})
    },
    validationsData: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: String
    }
  },
  methods: {
    initializeComponent () {
      this.validations = this.validationsData
      this.component = this.componentData
    },
    onInputValidationSameAs (optionsSameAsValidationSelected) {
      this.$emit('validations-changes', { [this.component.formObjectToSendToServerProperty]: this.validations })
      this.idOptionsSameAsValidationSelected = optionsSameAsValidationSelected?.id
      this.component.componentProps.labelOfFieldUsedForsameAsValidation = optionsSameAsValidationSelected?.label
      this.$emit('input', this.component)
    }
  },
  watch: {
    validationsData () {
      this.validations = this.validationsData
    },
    optionsSameAsValidation (newOne) {
      const optionSelected = newOne?.content?.find(e => e?.id === this.idOptionsSameAsValidationSelected)
      this.component.componentProps.labelOfFieldUsedForsameAsValidation = optionSelected?.label
      this.validations.sameAs = newOne?.content?.find(e => e?.id === this.idOptionsSameAsValidationSelected)?.value
      this.$emit('input', this.component)
    }
  },
  created () {
    this.initializeComponent()
  },
  mounted () {
    // eslint-disable-next-line no-unused-expressions
    this.$refs?.inputFocus?.$refs?.lmTextInput?.focus()
  }
}
